// src/components/Cards/CardCompany/CardCompany.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineOfficeBuilding, HiArrowRight } from "react-icons/hi";

const CardCompany = ({ company }) => {
    const navigate = useNavigate();

    const idcompany = company?.idcompany;
    const name = company?.name?.trim() || company?.abrev || "Compañía";
    const abrev = company?.abrev?.trim() || "";
    const logoPath = company?.logo_path || "";

    const handleClick = () => {
        if (!idcompany) return;
        navigate(`/campeonatos?idcompany=${idcompany}`);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            className="group relative flex h-full min-h-[280px] cursor-pointer flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 ease-out hover:-translate-y-1 hover:border-blue-200 hover:shadow-xl"
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label={`Ver campeonatos de ${name}`}
        >
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-blue-500 via-sky-400 to-cyan-400 opacity-80" />

            <div className="flex flex-1 flex-col p-5">
                <div className="flex min-h-[132px] items-center justify-center rounded-2xl border border-slate-100 bg-slate-50 p-4 transition-colors duration-300 group-hover:bg-slate-100">
                    {logoPath ? (
                        <img
                            src={logoPath}
                            alt={`Logo de ${name}`}
                            className="max-h-[96px] w-full object-contain"
                            onError={(event) => {
                                event.currentTarget.style.display = "none";
                                const fallback = event.currentTarget.nextElementSibling;
                                if (fallback) fallback.classList.remove("hidden");
                            }}
                        />
                    ) : null}

                    <div
                        className={`${logoPath ? "hidden" : "flex"} h-full w-full flex-col items-center justify-center rounded-xl bg-slate-100 text-slate-500`}
                    >
                        <HiOutlineOfficeBuilding className="mb-2 text-4xl text-slate-400" />
                        <span className="max-w-[180px] text-center text-sm font-semibold leading-tight text-slate-600">
                            {abrev || name}
                        </span>
                    </div>
                </div>

                <div className="mt-5 flex flex-1 flex-col">
                    <div className="mb-3 min-h-[28px]">
                        {abrev ? (
                            <span className="inline-flex max-w-full items-center rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-blue-700 ring-1 ring-inset ring-blue-100">
                                {abrev}
                            </span>
                        ) : null}
                    </div>

                    <h3 className="text-lg font-bold leading-snug text-slate-800">
                        {name}
                    </h3>

                    <div className="mt-auto pt-5">
                        <div className="flex items-center justify-between rounded-xl border border-slate-100 bg-slate-50 px-4 py-3 transition-colors duration-300 group-hover:border-blue-100 group-hover:bg-blue-50/70">
                            <span className="text-sm font-semibold text-slate-600 group-hover:text-blue-700">
                                Ver campeonatos
                            </span>
                            <HiArrowRight className="text-lg text-slate-400 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-blue-600" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(CardCompany);
